export const MAP_VIEW_ENABLED = 'mapView.enabled';
export const MAP_VIEW_STATION_DATA_FILENAME = 'mapView.stationDataFilename';
export const MAP_VIEW_GENRE_FILTERS = 'mapView.filters.genre';
export const MAP_VIEW_AFFILIATE_FILTERS = 'mapView.filters.affiliate';
export const MAP_VIEW_LANGUAGE_FILTERS = 'mapView.filters.language';

export const MAP_VIEW_ERROR_SPLASHSCREEN_TIMEOUT =
  'mapView.errorSplashScreenTimeout';
